/**
 * Created by Ram on 11/10/2016.
 */

import React, { Component } from 'react';
import { Link } from '@reach/router'

export default class CustomerSSO extends Component {
    render() {
        return (
            <div className="container-fluid mainContentBody-iframe">
                <div className="mainDiv-iframe ssoMainDiv-iframe">
                    <nav className="navbar navbar-iframe navbar-inverse admin-top-nav-iframe">
                        <div className="container-fluid">
                            <ul className="nav navbar-nav row">
                                <li className="col-sm-3 whiteColor add-top-margin">{}</li>
                                <li className="col-sm-3 col-sm-offset-6">
                                    <Link to={`/customer/${this.props.accountId}`} className="bluedotColor" >
                                        <span className="glyphicon glyphicon-arrow-left"></span> 
                                        BACK TO BLUE CONNECT PORTAL
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>

                    <div className="mainDivBody-iframe container-fluid">
                        <div className="dashboard-sso-user-iframe">
                            {this.props.ssoDisplay}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
